const SET_PROJECT_STATUS_ISVISIBLE = 'SET_PROJECT_STATUS_ISVISIBLE';

export { SET_PROJECT_STATUS_ISVISIBLE };



// WEBPACK FOOTER //
// ./src/containers/Inputs/ProjectStatus/constants.js